import { FC, ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SxProps, Theme } from '@mui/material/styles';
import OrangeButton from './OrangeButton';
import mergeSx from 'utils/mergeSx';

interface Cta {
  label: ReactNode;
  href?: string;
  to?: string;
}

interface Props {
  title?: string;
  body?: ReactNode;
  cta?: Cta;
  sx?: SxProps<Theme>;
  /** Escape hatch for fully custom banner content */
  children?: ReactNode;
}

const CtaBanner: FC<Props> = ({ title, body, cta, sx, children }) => (
  <Box
    sx={mergeSx(
      {
        background: theme => theme.palette.staticPages.gradient.cta,
        borderRadius: 4,
        px: { xs: 3, md: 5 },
        py: { xs: 4, md: 5.5 },
        textAlign: 'center',
      },
      sx,
    )}
  >
    {title && (
      <Typography variant="h2" sx={{ mb: 1, color: 'common.white' }}>
        {title}
      </Typography>
    )}
    {body && (
      <Typography
        variant="body1"
        sx={{ mb: cta ? 3 : 0, color: 'staticPages.text.onCta' }}
      >
        {body}
      </Typography>
    )}
    {children}
    {cta && (
      <OrangeButton href={cta.href} to={cta.to}>
        {cta.label}
      </OrangeButton>
    )}
  </Box>
);

export default CtaBanner;
